import { handleActions } from 'redux-actions'

import Analytics from './Analytics'
import { showError } from './actions'

const handleShowError = (state: any, { payload }: any) => {
  return state.set('error', payload)
}

export default handleActions(
  {
    [showError as any]: handleShowError,
  },
  new Analytics()
)
